import { CodeVerification } from '../../../lib/use-code-verification';
import { useTranslation } from '../../../lib/i18n';
import { RECORDER_MASK_CLASS } from '../../../lib/recorder-mask';
import styles from './OtpInput.module.css';

const GROUPS = [
  [0, 1, 2],
  [3, 4, 5],
];

export function OtpInput({ code, invalid }: { code: CodeVerification; invalid: boolean }) {
  const { t } = useTranslation();
  return (
    <div className={[styles.row, invalid && styles.error].filter(Boolean).join(' ')}>
      {GROUPS.map((group) => (
        <div className={styles.group} key={group[0]}>
          {group.map((i) => (
            <input
              key={i}
              ref={(el) => {
                code.inputsRef.current[i] = el;
              }}
              // A one-time code is a credential while it is valid: masked in session recordings, like a password.
              className={`${styles.box} ${RECORDER_MASK_CLASS}`}
              value={code.digits[i]}
              onChange={(e) => code.setDigit(i, e.target.value, e.target.selectionStart)}
              onPaste={code.onPaste}
              onKeyDown={(e) => code.onKeyDown(e, i)}
              inputMode="numeric"
              autoComplete={i === 0 ? 'one-time-code' : 'off'}
              // No maxLength: iOS Safari and Android Chrome clip an autofilled value to it, which left
              // the SMS suggestion filling only the first digit. `applyDigitInput` keeps one digit per box.
              autoFocus={i === 0}
              aria-label={t('onboarding.code.digit.label', { number: i + 1 })}
              aria-invalid={invalid || undefined}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
